import { db } from "common/config/Firebase"
import BusEvent from "common/services/BusEvent"

const ticketsCollection = db.collection('tickets')

const deleteTicketUseCase = ticket => {
    const newTicket = {...ticket, incorrect: !ticket.incorrect, tableData: null }
    delete newTicket.tableData

    BusEvent.publish(BusEvent.DELETE_TICKET, ticket)
    
    return ticketsCollection
        .doc(newTicket.id)
        .set(newTicket)
}

export default deleteTicketUseCase